export function operacaoAbastecimentosInRequest(params = {}) {
  return {
    type:
      '@operacaoabastecimentoexterno/OPERACAOABASTECIMENTOEXTERNO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoAbastecimentoExterno(
  idoperacaoabastecimentoexterno
) {
  return {
    type: '@operacaoabastecimentoexterno/FIND_OPERACAOABASTECIMENTOEXTERNO',
    payload: { idoperacaoabastecimentoexterno },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoabastecimentoexterno/FAILED_REQUEST',
  };
}

export function deleteOperacaoAbastecimentoExterno(params, query = {}) {
  return {
    type: '@operacaoabastecimentoexterno/DELETE_OPERACAOABASTECIMENTOEXTERNO',
    payload: { params, query },
  };
}

export function updateOperacaoAbastecimentoExterno(notaAtualizada, params) {
  return {
    type: '@operacaoabastecimentoexterno/UPDATE_OPERACAOABASTECIMENTOEXTERNO',
    payload: { notaAtualizada, params },
  };
}

export function storeOperacaoAbastecimentoExterno(
  operacaoabastecimentoexterno,
  params
) {
  return {
    type: '@operacaoabastecimentoexterno/STORE_OPERACAOABASTECIMENTOEXTERNO',
    payload: { operacaoabastecimentoexterno, params },
  };
}

export function successInRequest(
  operacaoabastecimentoexterno,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoabastecimentoexterno/SUCCESS_IN_REQUEST',
    payload: {
      operacaoabastecimentoexterno,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaoabastecimentoexterno) {
  return {
    type: '@operacaoabastecimentoexterno/SUCCESS_REQUEST',
    payload: { operacaoabastecimentoexterno },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoabastecimentoexterno/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoabastecimentoexterno/RECORD_FILTERING',
    payload: { params },
  };
}
